import { cn } from '@mint-lib/tw-utils';
import { cva, type VariantProps } from 'class-variance-authority';

const skeletonVariants = cva('animate-pulse bg-ui-active', {
  variants: {
    variant: {
      rounded: 'rounded-md',
      circle: 'rounded-full',
    },
  },
  defaultVariants: {
    variant: 'rounded',
  },
});

type SkeletonProps = React.ComponentProps<'div'> &
  VariantProps<typeof skeletonVariants>;
function Skeleton({ className, variant, ...props }: SkeletonProps) {
  return (
    <div
      data-slot="skeleton"
      className={cn(skeletonVariants({ variant, className }))}
      {...props}
    />
  );
}

export { Skeleton };
